import { PageHeaderTitleProps } from 'shared/mui/PageHeader';
import { ActionsPosition } from 'shared/mui/PageHeader/PageHeader';

import {
  PageHeaderStyled,
  ShowStyled,
  SimpleShowLayoutStyled,
  TabbedShowLayoutStyled,
} from './ShowPageTabbed.styled';

export type ShowPageTabbedProps = {
  headerTitle?: PageHeaderTitleProps;
  title: string;
  topPanel?: React.ReactNode;
  listName: string;
  children: React.ReactNode;
  actions?: (React.ReactElement | false)[] | false;
  actionsPosition?: ActionsPosition;
};

export const ShowPageTabbed: React.FC<ShowPageTabbedProps> = ({
  title,
  topPanel,
  listName,
  children,
  headerTitle,
  actions,
  actionsPosition,
}) => (
  <>
    <PageHeaderStyled
      actions={actions}
      actionsPosition={actionsPosition}
      breadCrumbs={{ currentPage: title, listName }}
      headerTitle={headerTitle}
    />
    {topPanel && <>{topPanel}</>}
    <ShowStyled actions={false}>
      <SimpleShowLayoutStyled>
        <TabbedShowLayoutStyled>{children}</TabbedShowLayoutStyled>
      </SimpleShowLayoutStyled>
    </ShowStyled>
  </>
);
